import { Component, ElementRef, ViewChild, Input } from '@angular/core';
import { FieldComponent } from 'tuain-ng-forms-lib';
import { IconDictionaryService } from 'src/app/services/icon-dictionary.service';

@Component({
  selector: 'app-password',
  templateUrl: './app-password.component.html',
})
export class AppPasswordComponent extends FieldComponent {
  inputType = 'password';
  icon: string;

  @Input() prefixIcon = '';
  @ViewChild('inputElement', { static: true }) inputElement: ElementRef;

  constructor(private iconDictionaryService: IconDictionaryService) {
    super();
  }

  override start() {
    super.start();
    const iconName = this.inputType === 'password' ? 'EYESLASH' : 'EYE';
    this.icon = this.iconDictionaryService.mapIcon(iconName);
  }

  override focus() {
    if (this.inputElement) {
      this.inputElement.nativeElement.focus();
    }
  }

  togglePwdView() {
    this.inputType = (this.inputType === 'password') ? 'text' : 'password';
    const iconName = this.inputType === 'password' ? 'EYESLASH' : 'EYE';
    this.icon = this.iconDictionaryService.mapIcon(iconName);
  }
}
